/**
 * Created by mh on 2017/5/23.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import AssetModel from './model/AssetModel';

const NumberPad = (pad, str, padLeft) => {
    if (typeof str === 'undefined') {
        return pad;
    }
    if (padLeft) {
        return (pad + str).slice(-pad.length);
    }
    return (str + pad).substring(0, pad.length);
};

const MsToSMPTETimeCode = (ms) => {
    const fd = 40;
    const sd = fd * 25; // 25 frames with 40ms
    const md = sd * 60;
    const hd = md * 60;

    const mms = (ms % hd);
    const h = (ms - mms) / hd;
    const sms = mms % md;
    const m = (mms - sms) / md;
    const fms = sms % sd;
    const s = (sms - fms) / sd;
    const ffs = fms % fd;
    const f = (fms - ffs) / fd;

    return `${NumberPad('00', h, true)}:${NumberPad('00', m, true)}:` +
        `${NumberPad('00', s, true)}:${NumberPad('00', f, true)}`;
};

const LabelsToList = (labels) => {
    if (labels) {
        return labels.map(l => <span className="badge badge-default">{l.name}</span>);
    }
    return '';
};

const sceneLine = scene => (
    <tr>
        <td rowSpan={2}>
            <img
                className="img-fluid"
                style={{ maxWidth: 200 }}
                src={scene.previewUrl}
                alt={`Thumbnail ${scene.name}`} />
        </td>
        <td>{scene.name}</td>
        <td>{scene.type}</td>
        <td>{scene.generator}</td>
        <td>{MsToSMPTETimeCode(scene.tcInMs)}</td>
        <td>{MsToSMPTETimeCode(scene.tcOutMs)}</td>
    </tr>
);
const tagLine = scene => (
    <tr>
        <td>{LabelsToList(scene.labels)}</td>
        <td />
        <td />
        <td />
        <td />
    </tr>
);

const AssetSceneRows = (asset) => {
    if (!asset) {
        return null;
    }
    const result = [];
    asset.scenes.map((scene) => {
        result.push(sceneLine(scene));
        result.push(tagLine(scene));
        return result;
    });
    return result;
};

@inject('auth') @observer
class AssetScenes extends React.Component {
    render() {
        const { asset } = this.props;
        // Only display if any
        if (asset.scenes && asset.scenes.length > 0) {
            return (
                <section>
                    <h2>Asset Scenes</h2>
                    <div className="table-responsive">
                        <table className="table table-sm table-striped">
                            <tbody>
                                {AssetSceneRows(asset)}
                            </tbody>
                        </table>
                    </div>
                </section>
            );
        }
        return null;
    }
}
AssetScenes.propTypes = {
    asset: PropTypes.instanceOf(AssetModel).isRequired,
};

export default injectIntl(AssetScenes);
